import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { UnusedSinceDurationCellRenderer } from "../column-def-cell-renderers/unused-since/UnusedSinceDurationCellRenderer";
import { regionColumnDef } from "../common/regionColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { resourceCreatedByColumnDef } from "../common/resourceCreatedByColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { resourceAccountColumnDef } from "../common/resourceAccountColumnDef";
import { getResourceSizeColumnDef } from "../common/getResourceSizeColumnDef";
import { unusedSinceDurationValueGetter } from "../../../utils/value-getters/unusedSinceDurationValueGetter";
import {
  FilteredAzDiskResourceItem,
  UnusedSince,
} from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const azDiskColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("Disk Name"),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("az_disk"),

  resourceAccountColumnDef,

  resourceTotalSpendColumnDef,

  resourceCreatedByColumnDef,

  getResourceCreationTimeColumnDef("Creation Time"),

  {
    field: "resource.unused_since",
    headerName: "Last Detached",
    valueGetter: unusedSinceDurationValueGetter,
    cellRenderer: ({
      data,
    }: ICellRendererParams<FilteredAzDiskResourceItem>) => {
      if (!data) {
        return null;
      }

      const unusedSince = data?.resource?.unused_since as UnusedSince;

      return <UnusedSinceDurationCellRenderer data={unusedSince} />;
    },
  },

  getResourceSizeColumnDef(),

  {
    field: "resource.sku",
    headerName: "Disk SKU",
  },
  {
    field: "resource.resource_group",
    headerName: "Resource Group",
  },

  regionColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
